import { Box, Button } from "@mui/material";
import { Help } from "@mui/icons-material";

export const HelpButton: React.FC = () => {
  return (
    <Box>
      <Button
        component="a"
        href="mailto:kelsey@sigilprotects.com?subject=Need help with product catalog upload"
        startIcon={<Help />}
        sx={{
          color: "#343a40",
          textTransform: "none",
          fontWeight: 500,
          fontSize: "14px",
          "&:hover": {
            backgroundColor: "rgba(52, 58, 64, 0.04)",
          },
        }}
      >
        Need help? Ask an expert
      </Button>
    </Box>
  );
};
